import { alpha, Theme, CSSObject } from "@mui/material"

type Elevation = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15| 16 | 17|18 |19| 20 |21| 22 |23| 24

export const translucentPaperBackgroundColor = ({elevation, opacity, theme}: {elevation: Elevation, opacity: number, theme: Theme}) => {
  return alpha((theme.components!.MuiPaper!.styleOverrides![`elevation${elevation}`]! as CSSObject).backgroundColor as string, opacity)
}